import { render, staticRenderFns } from "./my-dropdown.vue?vue&type=template&id=a85e3d40&"
import script from "./my-dropdown.vue?vue&type=script&lang=js&"
export * from "./my-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./my-dropdown.vue?vue&type=style&index=0&id=a85e3d40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports